import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "flex flex-col" };
import Breadcrumb from '@/components/Breadcrumb.vue';
import PaymentBanner from '@/components/pricing/PaymentBanner.vue';
export default /*#__PURE__*/ _defineComponent({
    __name: 'WorkspaceSubheader',
    setup(__props) {
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createVNode(Breadcrumb),
                (_ctx.$route.name !== 'showTeamRetro')
                    ? (_openBlock(), _createBlock(PaymentBanner, { key: 0 }))
                    : _createCommentVNode("", true)
            ]));
        };
    }
});
